module.exports = __webpack_public_path__ + "static/media/image-not-found.44613439.png";